import { render, staticRenderFns } from "./DisableSellCoins.vue?vue&type=template&id=25be8d16&scoped=true&"
import script from "./DisableSellCoins.vue?vue&type=script&lang=ts&"
export * from "./DisableSellCoins.vue?vue&type=script&lang=ts&"
import style0 from "./DisableSellCoins.vue?vue&type=style&index=0&id=25be8d16&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25be8d16",
  null
  
)

export default component.exports